import React from 'react'
import Snackbar from '../UI/Snackbar'
import { ActionModalType } from 'UI/Types/types'

type Props = {
  contactAction: ActionModalType
}

const ContactActionModal = ({ contactAction }: Props) => {
  switch (contactAction) {
    case 'create':
      return <Snackbar text="New Contact Created" />
    case 'edit':
      return <Snackbar text="Contact Updated" />
    case 'delete':
      return <Snackbar text="Contact Deleted" />
  }
}

export default ContactActionModal
